import {
  apply, call, put, select,
} from 'redux-saga/effects';
import { getClientAlias, getLanguage } from '../../reducers';
import { ClientMatchIdRequest } from '../../../lib/clientMatchId-api';
import { pollTillResponse } from '../utilLCR';
import { updateClientMatchId } from '../../actions/fishnet';

function* loadClientMatchId(matchId) {
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);

  const request = new ClientMatchIdRequest(matchId, clientAlias, language);
  const clientMatchId = yield apply(request, request.get);

  yield put(updateClientMatchId(clientMatchId, matchId));
}

function* pollClientMatchId(matchId) {
  yield call(pollTillResponse, {}, loadClientMatchId, matchId); // request once
}

export default pollClientMatchId;
